import { doc, getDoc, collection, query, where, getDocs, limit } from 'firebase/firestore';
import { db } from '../firebase';
import { slugify } from '../constants/site';

const FIREBASE_ID_PATTERN = /^[a-zA-Z0-9]{20}$/;

/**
 * Resolves a product document ID from a URL slug (seo_name, display_name slug, or raw id).
 * @returns {Promise<string|null>}
 */
export async function resolveProductIdFromSlug(slug) {
  if (!slug) return null;

  let productId = null;

  if (FIREBASE_ID_PATTERN.test(slug)) {
    const productSnap = await getDoc(doc(db, 'Products', slug));
    if (productSnap.exists()) {
      productId = productSnap.id;
    }
  }

  if (!productId) {
    const productSeoQuery = query(collection(db, 'Products'), where('seo_name', '==', slug));
    const productSeoSnap = await getDocs(productSeoQuery);
    if (!productSeoSnap.empty) {
      productId = productSeoSnap.docs[0].id;
    }
  }

  if (!productId && slug && !FIREBASE_ID_PATTERN.test(slug)) {
    const productsSnap = await getDocs(query(collection(db, 'Products'), limit(300)));
    const match = productsSnap.docs.find((d) => slugify(d.data()?.display_name) === slug);
    if (match) productId = match.id;
  }

  return productId;
}
